import Content from "./Content";
import { IWizardStep } from "../../../../wizard/types";
import validator from "../../validators/step3/validator";

export const createConfigStep3: IWizardStep = {
  width: "712px",
  titleConfig: {
    titleText: "Add course",
  },
  content: Content,
  validator: validator,
  stepName: "step3",
};
